import React from 'react';

import useStyles from './styles';

interface Props {
    icon: React.ComponentType<{ className?: string }>;
    title: string;
    count: number;
    className?: string;
}

const TooltipListItem: React.FC<Props> = ({ icon: Icon, title, count, className }) => {
    const { classes, cx } = useStyles();
    return (
        <div className={cx(classes.root, className)}>
            <Icon className={classes.icon} />
            <span className={classes.title}>{title}</span>
            <span className={classes.count}>{count}</span>
        </div>
    );
};

export default TooltipListItem;
